/**
 * Centralized storage key constants.
 * Using a const object prevents typos and enables refactoring.
 */
export const StorageKeys = {
  // ── Auth ──
  TOKEN: 'token',
  USER: 'user',
  GUEST: 'guest',
  FCM_TOKEN: 'fcmToken',
  LANG: 'lang',

  // ── Push (Capacitor Preferences) ──
  TOKEN_PUSH: 'tokenPush',
  REMOVE_CHANNELS: 'remove_channels',
  COOKIE_CONSENT: 'cookie_consent',

  // ── Navigation / State ──
  REDIRECT_URL: 'redirectUrl',
  HAS_OPENED_BEFORE: 'hasOpenedBefore',

  // ── Filters ──
  SELECTED_CATEGORY: 'selectedCategory',
  SELECTED_SUBCATEGORY: 'selectedSubcategory',
  IS_SUBCATEGORY: 'isSubcategory',
  ACTIVE_FILTERS: 'activeFilters',

  // ── Notifications ──
  NOTIFICATION_COUNT: 'notificationCount',
  UNREAD_MESSAGES: 'unreadMessages',

  // ── Articles / Posts ──
  ARTICLE_ID: 'articleId',
  USER_ID: 'userId',
  POST_TO_CREATE: 'postToCreate',
  PUBLIC_PROFILE: 'publicProfile',
  MAP_LOCATION_DATA: 'mapLocationData',
  CREATE_POST_FORM_STATE: 'create-post-form-state',

  // ── Chat ──
  REFRESH_CHATS: 'refreshChats',
  CHAT_WAS_READ: 'chatWasRead',
  CHAT_READ_TIMESTAMP: 'chatReadTimestamp',

  // ── Stripe ──
  STRIPE_CONNECT_STATE: 'stripe_connect_state',
  STRIPE_PUBLISHABLE_KEY: 'stripe_publishable_key',

  // ── Firebase cleanup ──
  FIREBASE_AUTH_USER: 'firebase:authUser',
  FIREBASE_REDIRECT_EVENT: 'firebase:redirectEvent',

  // ── Login social por redirección (web móvil, p. ej. Chrome) ──
  // Persisten el proveedor y la aceptación de términos mientras la página se
  // recarga durante el flujo signInWithRedirect.
  PENDING_SOCIAL_PROVIDER: 'pendingSocialProvider',
  PENDING_SOCIAL_TERMS: 'pendingSocialTermsAcceptedAt',
} as const;

export type StorageKey = typeof StorageKeys[keyof typeof StorageKeys];
